angular.module('admin.permissions').run(function (PermPermissionStore, UserManager, config) {

    var permissionSets = {
        "atendimento": [
            'admin.subscriptions',
            'admin.campaigns',
            "customer.changeCredentials",
            "customer.impersonate",
            "subscription.change_admin",
            "reports.subscriptions",
            'reports',
            "reports.basic",
            'reports.myce',
            'reports.subscriptions_flow',
            "admin.prospects",
            'subscription.freeplay.view',
            'subscription.freeplay.edit',
            'reports.commercial_report',
            'reports.removed_subordinates'
        ], "financeiro": [
            'admin.subscriptions',
            'admin.campaigns',
            "subscription.vindi.edit",
            "customer.impersonate",
            'reports',
            "reports.revenues",
            //'subscription.revenues',
            "reports.subscriptions",
            'reports.subscriptions_flow',
            'reports.commercial_report'
        ], "admin": [
            'admin.subscriptions',
            'admin.campaigns',
            "admin.logs",
            'reports',
            'reports.favorites',
            'reports.myce',
            "subscription.import_users",
            'reports.subscriptions_flow',
            'reports.removed_subordinates'
        ], "publicidade": [
            'reports',
            "reports.mailing",
            'admin.campaigns',
            'admin.campaigns.edit',
            'trials.import'
        ], "users": [
            'admin.users.view',
            'admin.users.edit'
        ]
    };



    var checkPermission = function (permission) {

        return new Promise((resolve, reject) => {
            UserManager.getCurrent().then(function (u) {
                let { roles } = u;
                for (var role of roles) {
                    var roleSet = permissionSets[role];

                    if (!roleSet) {
                        continue;
                    }
                    if (roleSet.indexOf(permission) >= 0)
                        resolve();
                }
                reject();
            }, () => reject());
        });
    }

    for (var role in permissionSets) {
        var permissions = permissionSets[role];

        for (let permission of permissions) {
            PermPermissionStore.definePermission(permission, checkPermission);
        }
    }

});
